export const MIN_REQUIRED_ATTRIBUTES_TO_COMPARE = 2;
